import SharedAccountsLayout from "@components/core/SharedAccountsLayout";
import ReferralShare from "./ReferralShare";
import ReferralTriptych from "./ReferralTriptych";
import ReferralFaq from "./ReferralFaq";

const Referral = () => {
  return (
    <div>
      <SharedAccountsLayout title="title_referral" />

      <ReferralShare />
      <ReferralTriptych />
      <ReferralFaq />
    </div>
  );
};

export default Referral;
